<template>
  <div class="flex flex-col gap-2 h-full">
    <!-- 移动同步 -->
    <div class="p-4 flex-1 flex items-center gap-2 glass-frosted rounded-8xl">
      <Icon icon="Technology-Wireframe-QuickTrigger" class="size-9 text-black-white" />
      <div class="flex-1 flex flex-col">
        <h3 class="text-l-medium text-black-white">
          {{ $t('parameters.switchGroup.motionSync.title') }}
        </h3>
        <p class="text-s-medium text-text-glass-default">
          {{ $t('parameters.switchGroup.motionSync.description') }}
        </p>
      </div>
      <Switch
        size="lg"
        :model-value="ctx.state.switchGroup.value.motionSync"
        @update:model-value="ctx.actions.setMotionSync"
      />
    </div>
    <!-- 直线修正 -->
    <div class="p-4 flex-1 flex items-center gap-2 glass-frosted rounded-8xl">
      <Icon icon="Technology-Wireframe-Line" class="size-9 text-black-white" />
      <div class="flex-1 flex flex-col">
        <h3 class="text-l-medium text-black-white">
          {{ $t('parameters.switchGroup.lineCorrection.title') }}
        </h3>
        <p class="text-s-medium text-text-glass-default">
          {{ $t('parameters.switchGroup.lineCorrection.description') }}
        </p>
      </div>
      <Switch
        size="lg"
        :model-value="ctx.state.switchGroup.value.lineCorrection"
        @update:model-value="ctx.actions.setLineCorrection"
      />
    </div>
    <!-- 波浪修正 -->
    <div class="p-4 flex-1 flex items-center gap-2 glass-frosted rounded-8xl">
      <Icon icon="Technology-Wireframe-Wave" class="size-9 text-black-white" />
      <div class="flex-1 flex flex-col">
        <h3 class="text-l-medium text-black-white">
          {{ $t('parameters.switchGroup.waveCorrection.title') }}
        </h3>
        <p class="text-s-medium text-text-glass-default">
          {{ $t('parameters.switchGroup.waveCorrection.description') }}
        </p>
      </div>
      <Switch
        size="lg"
        :model-value="ctx.state.switchGroup.value.waveCorrection"
        @update:model-value="ctx.actions.setWaveCorrection"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { Icon, Switch } from '@rapoo/element'
  import type { ModuleSize } from '../utils/types'
  import type { ParametersContext } from '../../composables/useParameters'

  const props = defineProps<{
    parameters: ParametersContext
    size?: ModuleSize
  }>()

  const ctx = props.parameters
</script>
